import HTTP from './axios';

const AuthService = {
  login: (credentials) => {
    const { email, password } = credentials;
    return HTTP.post('/auth', { email, password })
      .then(response => response.data.data);
  },
  recoverPassword: phoneOrEmail => HTTP.post('/recoverPassword', { phoneOrEmail })
    .then(response => response.data),
  renew: renewToken => HTTP.post('/renew', { renewToken })
    .then(response => response.data.data),
};

export default AuthService;
